import { render, staticRenderFns } from "./PotvrdaPovratnice.vue?vue&type=template&id=70395515&scoped=true&"
import script from "./PotvrdaPovratnice.vue?vue&type=script&lang=ts&"
export * from "./PotvrdaPovratnice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70395515",
  null
  
)

export default component.exports